import { RootState } from '@Common/models/redux/store';
import PremiumButton from '@Common/quillElements/button/PremiumButton';
import {
  Box,
  Button,
  IconButton,
  Slide,
  Typography,
  Close,
  makeStyles,
} from '@quillbot/design-system';
import QuillLocalStorage from 'core/utils/localStorageClient';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Track from '../handlers/track';

interface StyleProps {
  showPremiumUpsale: boolean;
  isMobile: boolean;
}
const useStyles = makeStyles((theme) => ({
  container: {
    margin: '10px',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'space-between',
    opacity: (props: StyleProps) => (props.showPremiumUpsale ? 1 : 0),
    transition: 'opacity 0.3s ease-in-out',
    alignItems: 'center',
    padding: '10px 8px 10px 16px',
    [theme.breakpoints.between('sm', 1048)]: {
      flexDirection: 'column',
    },
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('md')]: {
      borderRadius: '0px',
      padding: '10px 0px 10px 12px',
      margin: '0px',
      backgroundColor: (props: StyleProps) =>
        props.isMobile ? theme.palette.error.dark : 'none',
    },
  },
  premiumBtn: {
    padding: '0px 13.5px 0px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0px',
    },
  },
  textButton: {
    '&:hover': {
      background: 'none',
    },
  },
  text: {
    [theme.breakpoints.between('sm', 1048)]: {
      marginBottom: '15px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
  },
}));

const PremiumUpsale = (props: { text: string }) => {
  const [showPremiumUpsale, setShowPremiumUpsale] = useState(false);
  const isMobile = useSelector(
    (state: RootState) => state.common.platform?.isMobile
  );
  const classes = useStyles({ showPremiumUpsale, isMobile });

  useEffect(() => {
    setTimeout(() => {
      const checkPremiumLimits = JSON.parse(
        QuillLocalStorage.getInstance().get('showPremiumUpsaleModal', '{}')
      );
      let showPremium = true;

      if (
        checkPremiumLimits.date === new Date().getDate() &&
        checkPremiumLimits.month === new Date().getMonth()
      ) {
        showPremium = checkPremiumLimits.value;
      }

      if (showPremium) {
        Track.premiumUpsaleAction('pphr/system/shown_premium_upsale');
        setShowPremiumUpsale(true);
      }
    }, 5);
  }, []);

  const handleClose = () => {
    setShowPremiumUpsale(false);
    Track.premiumUpsaleAction('pphr/user/closed_premium_upsale');
    QuillLocalStorage.getInstance()?.set(
      'showPremiumUpsaleModal',
      JSON.stringify({
        value: false,
        date: new Date().getDate(),
        month: new Date().getMonth(),
      })
    );
  };

  const handleClick = () => {
    setShowPremiumUpsale(false);
  };

  return (
    showPremiumUpsale && (
      <div style={{ overflow: 'hidden' }}>
        <Slide in direction="up" timeout={300}>
          <Box boxShadow={3} className={classes.container}>
            <Typography className={classes.text}>{props.text}</Typography>
            <div>
              <PremiumButton
                className={classes.premiumBtn}
                style={{
                  paddingLeft: '13.5px',
                  paddingRight: '13.5px',
                  marginRight: '8px',
                }}
                referrer="pphrWordLimitToastr"
                text="Go Premium"
                color="primary"
                close={handleClick}
              />
              {!isMobile ? (
                <Button
                  onClick={handleClose}
                  className={classes.textButton}
                  color="primary"
                >
                  Maybe Later
                </Button>
              ) : (
                <IconButton
                  onClick={handleClose}
                  style={{ padding: '4px' }}
                  size="large"
                >
                  <Close />
                </IconButton>
              )}
            </div>
          </Box>
        </Slide>
      </div>
    )
  );
};

export default PremiumUpsale;
